import * as types from '../../../lib/actionTypes.es6';

export function initialState() {
  return {
    loading: false,
    error: null,
    month: null,
    agentGuid: null,
    rows: [],
    truncated: false
  };
}

export default function commissionStatementReducer(state, action) {
  var next = state || initialState();

  switch (action.type) {
    case types.GET_COMMISSION_STATEMENT_REQUEST:
      return Object.assign({}, next, {
        loading: true,
        error: null,
        // The previous agent's rows must not sit under a new agent's heading
        // while the new statement loads.
        rows: [],
        truncated: false,
        month: (action.payload || {}).month || null,
        agentGuid: (action.payload || {}).agentGuid || null
      });

    case types.GET_COMMISSION_STATEMENT_SUCCESS:
      return Object.assign({}, next, {
        loading: false,
        error: null,
        month: action.payload.month,
        agentGuid: action.payload.agentGuid,
        rows: action.payload.rows || [],
        truncated: !!action.payload.truncated
      });

    case types.GET_COMMISSION_STATEMENT_FAILURE:
      return Object.assign({}, next, {
        loading: false,
        error: action.payload || { message: 'Could not build the statement' },
        rows: []
      });

    case types.RESET_COMMISSION_STATEMENT:
      return initialState();

    default:
      return next;
  }
}
